// @mui
import {
  Box,
  Container,
  InputAdornment,
  Stack,
  Toolbar,
  Typography,
  useTheme,
} from '@mui/material';

import { IconButton } from '@mui/material';

import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link as RouterLink } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { IconButtonAnimate } from '../../../components/animate';
import { HEADER } from '../../../config';
import useOffSetTop from '../../../hooks/useOffSetTop';

//
import AccountPopover from './AccountPopover';
import NotificationsPopover from './NotificationsPopover';
import { DesktopNavigation } from './desktop/desktop-navigation';
import { RootStyle } from './index.style';
import { IDashboardHeaderProps } from './index.types';

// import { FeedbackHeaderIcon } from 'assets/icons';
import { MobileNavigation } from './mobile/mobile-navigation';
import { LogoIcon } from 'assets/icons';
import SearchV2Icon from 'assets/icons/SearchV2Icon';
// import ButtonArrowIcon from 'assets/icons/survey/ButtonArrowIcon';
import { Logo, RHFTextField } from 'components';
import { Iconify } from 'components';
// import { FAQ_ROUTE } from 'constants/paths';
import * as PATHS from 'constants/paths';
// import { isFaqEnabled } from 'constants/user';
import { useTranslations, useResponsive } from 'hooks';
// import { FindMoreButton } from 'pages/DashboardV2/WidgetContents/style';
import { FormProvider } from 'providers';
import { useAuthSelector } from 'stores';
import { useDashboardStore } from 'stores/dashboard';
import { useHeaderStore } from 'stores/header';
// ----------------------------------------------------------------------

const DashboardHeader = ({
  onOpenSidebar,
  // isCollapse = true,
  verticalLayout = false,
  isHeaderLight,
  bgColor,
}: IDashboardHeaderProps) => {
  //hooks
  const i18n = useTranslations();
  const { user } = useAuthSelector();

  // getMenu from store
  const { menu } = useHeaderStore();

  // show / hide menu
  const [showMenu] = useState(false); // menu hidden by default

  const [userHasEmptySearchBar, setUserHasEmptySearchBar] = useState(false);
  const isOffset =
    useOffSetTop(HEADER.DASHBOARD_DESKTOP_HEIGHT) && !verticalLayout;

  const formDefaultValues = {
    search_library: undefined,
  };

  const methods = useForm<{ search_library: string }>({
    defaultValues: formDefaultValues,
  });

  const navigate = useNavigate();
  const isDesktop = useResponsive('up', 'lg');
  const isMdDown = useResponsive('down', 'md');
  const theme = useTheme();
  const wSearchbar = methods.watch('search_library') as unknown as string;

  const searchInLibrary = () => {
    const text = methods.getValues('search_library');
    useDashboardStore.setState(prev => ({
      ...prev,
      librarySearchText: text,
      hasDashboardFilters: true,
    }));
    navigate(PATHS.EDUCATION);
  };

  useEffect(() => {
    if (userHasEmptySearchBar) {
      useDashboardStore.setState(prev => ({
        ...prev,
        librarySearchText: '',
        hasDashboardFilters: true,
      }));
      setUserHasEmptySearchBar(false);
    }
  }, [userHasEmptySearchBar]);

  const isLibrary = window.location.pathname.includes(PATHS.EDUCATION);

  // const offset = useOffSetTop(HEADER.H_DESKTOP);
  // const isAuthenticated = true; //TODO useIsAuthenticated();

  const isLight = bgColor === 'white' || isHeaderLight;

  const MobileContent = () => (
    <Container sx={{ display: { xs: 'block', lg: 'none' } }}>
      <Stack direction={'row'} flex={1} gap={2}>
        <RouterLink
          to="/"
          style={{ display: 'flex', flex: 1 }}
          aria-label="Home"
        >
          <LogoIcon fill={isLight ? 'white' : undefined} />
        </RouterLink>
        <MobileNavigation
          items={menu}
          color={isLight ? 'white' : undefined}
          // isAuthenticated={isAuthenticated}
        />
      </Stack>
    </Container>
  );

  const DesktopContent = () => (
    <Container sx={{ display: { xs: 'none', lg: 'block' } }}>
      <Stack flexDirection={'row'} flex={1} gap={2}>
        {/* <RouterLink
          to="/"
          style={{
            display: 'flex',
            alignItems: 'center',
            marginRight: theme.spacing(4),
          }}
          aria-label="Home"
        >
          <LogoIcon fill={isLight ? 'white' : undefined} />
        </RouterLink> */}
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <DesktopNavigation items={menu} />
        </Box>
      </Stack>
    </Container>
  );

  return (
    <RootStyle
      isCollapse={true}
      isOffset={isOffset}
      verticalLayout={verticalLayout}
    >
      <Toolbar
        sx={{
          minHeight: '100% !important',
          px: { lg: 5 },
          backgroundColor: '#FFFFFF',
        }}
      >
        {isDesktop && verticalLayout && <Logo sx={{ mr: 2.5 }} />}

        {!isDesktop && (
          <IconButtonAnimate
            onClick={onOpenSidebar}
            sx={{ mr: 1, color: 'text.primary' }}
          >
            <Iconify icon="eva:menu-2-fill" />
          </IconButtonAnimate>
        )}
        {!isMdDown && !isLibrary ? (
          <FormProvider
            methods={methods}
            onKeyDown={event => {
              if (event.key === 'Enter') {
                event.preventDefault();
              }
            }}
          >
            <Stack flexDirection={'row'} alignItems={'center'} gap={'16px'}>
              <RHFTextField
                name="search_library"
                onKeyDown={event => {
                  if (event.key === 'Enter') {
                    searchInLibrary();
                    event.preventDefault();
                  }
                }}
                placeholder="Cerca contenuti qui..."
                onChange={e => {
                  !e.target.value && setUserHasEmptySearchBar?.(true);
                }}
                InputProps={{
                  disableUnderline: true,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchV2Icon />
                    </InputAdornment>
                  ),
                  endAdornment:
                    wSearchbar?.length > 0 ? (
                      <IconButton
                        onClick={() => {
                          methods.setValue('search_library', '');
                          setUserHasEmptySearchBar?.(true);
                        }}
                      >
                        <Iconify
                          icon="mdi:close-circle-outline"
                          style={{ width: '18px', height: '18px' }}
                        />
                      </IconButton>
                    ) : null,
                }}
                sx={{ width: '350px' }}
                variant="standard"
              />
            </Stack>
          </FormProvider>
        ) : null}

        <Box
          sx={{
            flexGrow: 1,
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          {showMenu && (
            <>
              <MobileContent />
              <DesktopContent />
            </>
          )}
        </Box>
        <Stack
          direction="row"
          alignItems="center"
          gap="20px"
          spacing={{ xs: 0.5, sm: 1.5 }}
        >
          <Stack>
            {isDesktop && (
              <>
                <Typography
                  variant="subtitle2"
                  sx={{ color: theme.palette.primary.dark, textAlign: 'right' }}
                >
                  {i18n.common.header.profileMessage}{' '}
                  {user?.field_name && user?.field_surname
                    ? `${user?.field_name} ${user?.field_surname}`
                    : user?.name}
                </Typography>
                <Typography
                  variant="caption"
                  sx={{ color: theme.palette.primary.dark, textAlign: 'right' }}
                >
                  {user?.field_role}
                </Typography>
              </>
            )}
          </Stack>
          <AccountPopover isOffset={isOffset} />
          {/* {isFaqEnabled ? (
            <IconButton
              sx={{
                height: '40px',
                width: '40px',
              }}
              onClick={() => navigate(FAQ_ROUTE)}
            >
              <FeedbackHeaderIcon />
            </IconButton>
          ) : null} */}
          <NotificationsPopover />
        </Stack>
      </Toolbar>
    </RootStyle>
  );
};

export { DashboardHeader };
